import api from '../api/axios';

export interface ServiceProvider {
  id: number;
  attributes?: {
    name: string;
    type: 'company' | 'person';
    phone: string;
    email?: string;
    address?: string;
    area?: string;
    locationLatitude?: number;
    locationLongitude?: number;
    areaPolygons?: {
      polygons: Array<{
        id: string;
        name: string;
        coordinates: number[][];
      }>;
      areaString?: string;
    };
    isActive: boolean;
    schedule: any;
    notes?: string;
    bankAccountNumber?: string;
    bankName?: string;
    bicCode?: string;
    iban?: string;
    createdAt: string;
    updatedAt: string;
  };
  name?: string;
  type?: 'company' | 'person';
  phone?: string;
  email?: string;
  address?: string;
  area?: string;
  locationLatitude?: number;
  locationLongitude?: number;
  areaPolygons?: {
    polygons: Array<{
      id: string;
      name: string;
      coordinates: number[][];
    }>;
    areaString?: string;
  };
  isActive?: boolean;
  schedule?: any;
  notes?: string;
  bankAccountNumber?: string;
  bankName?: string;
  bicCode?: string;
  iban?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const serviceProviderService = {
  async getAll(params?: any) {
    const response = await api.get('/service-providers', { params });
    return response.data;
  },

  async getById(id: number) {
    const response = await api.get(`/service-providers/${id}`);
    return response.data;
  },

  async create(data: Partial<ServiceProvider>) {
    const response = await api.post('/service-providers', { data });
    return response.data;
  },

  async update(id: number, data: Partial<ServiceProvider>) {
    const response = await api.put(`/service-providers/${id}`, { data });
    return response.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/service-providers/${id}`);
    return response.data;
  }
};

